import PropTypes from 'prop-types';
import React, {useRef} from 'react';
import Dialog from '@mui/material/Dialog';
import {BrickContext} from 'olympe';
import {ConditionTypeContent} from '../../dialogs/transportCosts/ConditionTypeContent.jsx';
import {ThemeProvider} from '@mui/styles';
import {EZPRTheme} from '../../_theme.js';
import {Button, DialogActions, DialogContent, DialogTitle, IconButton} from '@mui/material';
import {LoadingButton} from '@mui/lab';
import {ezprOrange} from '../../_helpers.js';
import ClearIcon from '@mui/icons-material/Clear';
import CloseIcon from '@mui/icons-material/Close';
import {useFieldEditability} from '../utils/useFieldEditability.js';

/**
 *
 * @param {TransportCostsConditionTypePopup.propTypes} props
 * @return {JSX.Element}
 */
export function TransportCostsConditionTypePopup(props) {
    const dialogContentRef = useRef();
    const {isDisabled} = useFieldEditability(props.prTag, {context: props.context});
    const confirmDisabled = isDisabled('transportCosts.confirm');

    const handleCancel = () => {
        props.onClose();
    };
    const handleConfirm = () => {
        dialogContentRef?.current?.submit();
        setTimeout(()=>{
            props.onConfirm(props.selectedMaterialIds, props.materialId, dialogContentRef?.current?.selectedConditions);
        }, 300);
    };
    // new column subtotal + pagination
    return (
        <ThemeProvider theme={EZPRTheme}>
            <Dialog open={props.open} onClose={handleCancel} fullWidth maxWidth={'xl'}>
                <div className={'pr-popup-header'}>
                    <DialogTitle>Select condition types</DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={props.onClose}
                        sx={{
                            color: ezprOrange,
                        }}>
                        <CloseIcon
                            sx={{
                                width: '50px',
                                height: '50px',
                            }}
                        />
                    </IconButton>
                </div>
                <DialogContent className={'popup-scroller'} sx={{overflowY: 'scroll'}}>
                    <ConditionTypeContent
                        prTag={props.prTag}
                        context={props.context}
                        selectedMaterialIds={props.selectedMaterialIds}
                        materialId={props.materialId}
                        ref={dialogContentRef}
                    />
                </DialogContent>
                <DialogActions>
                    {confirmDisabled && (
                        <LoadingButton
                            sx={{
                                'color': '#fff',
                                'backgroundColor': ezprOrange,
                                '&:hover': {backgroundColor: '#F2ae49'},
                                ':disabled': {backgroundColor: 'rgba(0,0,0,0.26)'},
                            }}
                            variant={'outlined'}
                            onClick={props.onClose}
                            loading={false}
                        >
                            <span>Close</span>
                        </LoadingButton>
                    )}
                    {!confirmDisabled && (
                        <>
                            <Button
                                style={{backgroundColor: '#FF0000', color: 'white', borderColor: '#FF0000'}}
                                variant={'outlined'}
                                onClick={props.onClose}
                                startIcon={<ClearIcon/>}>
                    Cancel
                            </Button>
                            <LoadingButton
                                sx={{
                                    'color': '#fff',
                                    'backgroundColor': ezprOrange,
                                    '&:hover': {backgroundColor: '#F2ae49'},
                                    ':disabled': {backgroundColor: 'rgba(0,0,0,0.26)'},
                                }}
                                variant={'outlined'}
                                onClick={handleConfirm}
                                loading={false}
                            >
                                <span>Confirm</span>
                            </LoadingButton>
                        </>
                    )}
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}

TransportCostsConditionTypePopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    context: PropTypes.instanceOf(BrickContext).isRequired,
    prTag: PropTypes.string,
    selectedMaterialIds: PropTypes.array,
    materialId: PropTypes.number,
};
